import React from 'react'
import {
  useNavigate
} from "react-router-dom"
import { map, compact, get, filter, find } from 'lodash'

import EyeLiner from './EyeLiner'
import MapMarker from '../assets/images/map_marker.svg'
import EyebrowHours from './EyebrowHours'
import EcsLogoSvg from '../assets/images/ecs_logo.svg'
import CloseSvg from '../assets/images/close.svg'
import { displayHours } from '../helpers/officeHours'
import { displayPhone } from '../helpers/clinic'
import ClinicCard from './ClinicCard'

export default ({data}) => {
  if (!data) return null

  const [showLocations, setShowLocations] = React.useState(false)
  const navigate = useNavigate()
  const path = window.location.pathname.split('/')[1] // purge leading slash
  const [cachePositionY, setCachedPositionY] = React.useState(0)

  const clinic = find(data.clinics, (c) => {
    return c.url === path
  })

  const onSelectLocation = (e) => {
    // document.body.style.position = !showLocations ? 'fixed' : ''
    const cacheY = window.pageYOffset
    setCachedPositionY(cacheY)
    setShowLocations(!showLocations)
  }

  const onDismissLocations = (e) => {
    // document.body.style.position = ''
    document.documentElement.scrollTop = cachePositionY
    setShowLocations(false)
  }

  
  const selectClinic = (c) => {
    onDismissLocations()
    let pathElements = window.location.pathname.split('/')
    pathElements = compact(pathElements)

    if (clinic) {
      pathElements.shift()
    }
    pathElements.unshift(c.url)
    navigate(`/${pathElements.join('/')}`)
  }




  const clinicName = (clinic && clinic.name) || "Select a Location"
  const clinicButtonTitle = clinic ? 
    `Currently viewing ${clinic.name} - Click to select another Eye Clinic of Seattle` :
    'Select an Eye Clinic of Seattle'

  const bannerMessages = clinic ? filter(data.bannerMessages, (bm) => { return bm.clinics.includes(path)} ) :
    data.bannerMessages

  return <div>
    <EyeLiner messages={bannerMessages} />
    <div className="">
      <div className="max-w-6xl mx-auto px-4 py-2">
        <div className="flex gap-x-1 md:gap-x-4 items-center text-xs md:text-sm">
          <div className="flex-1 md:block"></div>
          <div className="flex-0 md:text-sm z-20">
            <button
              className="flex items-center cursor-pointer"
              onClick={onSelectLocation}
              title={clinicButtonTitle}
            >
              <div className="mr-1 pointer-events-none"><img src={MapMarker} className="h-[16px]"/></div>
              <div className="underline pointer-events-none">{clinicName}</div>
            </button> 
          </div>
          <EyebrowHours clinic={clinic} />
        </div>
      
      </div>
    </div>

    <div className={`z-50 fixed text-lg w-full top-0 bg-[#fafafa] overflow-hidden mobile-menu transition-height duration-500 ease-in-out h-[0%] ${showLocations ? 'h-[100%] block' : ''} `}>
      <div className="max-w-2xl mx-auto px-4 py-8 text-center relative">
        <div className="absolute right-8 top-8 cursor-pointer" onClick={onDismissLocations}><img src={CloseSvg} className="w-4 h-4" alt="Dismiss Clinic Locations" /></div>
        <img src={EcsLogoSvg} className="w-64 mx-auto mb-4" />
        <div className="block text-sm mb-4">Choose from {data.clinics.length} locations to serve you</div>
        <div className="md:flex gap-4 md:gap-4 justify-center">
          {
            map(data.clinics, (c, index) => {
              return <ClinicCard 
                  globalData={data} 
                  clinic={c}
                  key={`eyebrow-card-${index}`} 
                  callback={selectClinic}
                  cta="select this clinic"
                />
            })
          }
        </div>
      </div>
    </div>
  </div>
}